import { render, staticRenderFns } from "./slidebutton.vue?vue&type=template&id=68afeb5a&scoped=true&"
import script from "./slidebutton.vue?vue&type=script&lang=js&"
export * from "./slidebutton.vue?vue&type=script&lang=js&"
import style0 from "./slidebutton.vue?vue&type=style&index=0&id=68afeb5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68afeb5a",
  null
  
)

export default component.exports